export default __webpack_public_path__ + "static/media/map.7ab1b992.jpg";